
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const TeacherFormMasterRoute = ({ children }) => {
    const { currentUser, userData, loading } = useAuth();

    if (loading) {
        return <div className="loading-fullscreen">Loading...</div>;
    }

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    if (!userData) {
        return <div className="loading-fullscreen">Loading user data...</div>;
    }

    const userRole = userData.role?.toLowerCase() || '';
    const allowedRoles = ['teacher', 'form-master'];

    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
};

export default TeacherFormMasterRoute;
